import { IncentiveTrigger } from './incentive-trigger.enum';
import { IncentiveWageType } from './incentive-wage-type.enum';

export enum IncentiveBasis {
  Always = 0,
  Logs = 1,
  HOS = 2
}

export const IncentiveBasisMapping: Record<IncentiveBasis, string> = {
  [IncentiveBasis.Always]: 'Always Pay',
  [IncentiveBasis.Logs]: 'Log Based',
  [IncentiveBasis.HOS]: 'HOS Based'
};

export const IncentiveBasisTriggersMapping: Record<IncentiveBasis, IncentiveTrigger[]> = {
  [IncentiveBasis.Always]: [IncentiveTrigger.OneTime],
  [IncentiveBasis.Logs]: [
    IncentiveTrigger.OneTime,
    IncentiveTrigger.PerDay,
    IncentiveTrigger.PerDepartureDelay,
    IncentiveTrigger.PerReRouteDelay,
    IncentiveTrigger.DayCount
  ],
  [IncentiveBasis.HOS]: [IncentiveTrigger.IfShiftStart, IncentiveTrigger.PerShiftStart]
};

export const IncentiveBasisWageTypeMapping: Record<IncentiveBasis, IncentiveWageType[]> = {
  [IncentiveBasis.Always]: [IncentiveWageType.FixedAmount],
  [IncentiveBasis.Logs]: [
    IncentiveWageType.FixedAmount,
    IncentiveWageType.ReconciledMiles,
    IncentiveWageType.SettlementMiles,
    IncentiveWageType.SettlementDayMiles,
    IncentiveWageType.SettlementWeekReconciledDays,
    IncentiveWageType.Hours
  ],
  [IncentiveBasis.HOS]: [IncentiveWageType.FixedAmount]
};
